import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import UserService from "../../services/UserService";

let initialState = {
    user: null,
    isLoading: true,
    error: null,
}

export const getUserByToken = createAsyncThunk(
    'getUserByToken',
    async (_, { getState, rejectWithValue, dispatch }) => {
        try {
            const response = await UserService.getUserByToken();
            return response?.data;
        } catch (error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem('Authorization');
                dispatch(clearUser());
            }
            return rejectWithValue(error?.response);
        }
    },
);

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        clearUser(state) {
            state.user = null;
        },
        setUserState(state, action) {
            state.user = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getUserByToken.pending, (state) => {
                state.isLoading = true;
                state.user = null;
                state.error = null;
            })
            .addCase(getUserByToken.fulfilled, (state, action) => {
                state.user = action.payload;
                state.isLoading = false;
            })
            .addCase(getUserByToken.rejected, (state, action) => {
                state.isLoading = false;
                state.user = null;
                state.error = action.payload;
                // localStorage.removeItem('ExpirationDate');
            })
    }
});

export const {
    clearUser, setUserState
} = userSlice.actions;

export default userSlice.reducer;